/*
 *
 * CostsShopPickerPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 02-Oct-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  closeLabel: <PortalMessage id='t.app.shopSelector.close' defaultMessage='chiudi' />,
  shopPickerSelector: <PortalMessage id='t.app.shopSelector.shopPickerSelector' defaultMessage='Selettore punto vendita' />,
  chooseShopLabel: <PortalMessage id='t.app.shopSelector.costs.chooseShopLabel' defaultMessage='Scegli i punti vendita di cui vuoi visualizzare i dati.' />,
  whatGroupsAreInfo: <PortalMessage id='t.app.shopSelector.whatGroupsAreInfo' defaultMessage='Che cosa sono i gruppi?' />,
  applySelection: <PortalMessage id='t.app.shopSelector.applySelection' defaultMessage='Applica selezione' />,
  noShopAvailable: <PortalMessage id='t.app.shopSelector.noShopAvailable' defaultMessage='Nessun punto vendita disponibile' />,
  onlyPosTerminals: <PortalMessage id='t.app.shopSelector.groupTitle4' defaultMessage='Solo terminali POS' />
}

export default formattedMessage
